import type WorkflowFormData from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/FormData/WorkflowFormData';
import WorkflowDraftContext from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/Providers/WorkflowDraftProvider/WorkflowDraftContext';
import * as React from 'react';

type Props = {
	readonly initialDraft: WorkflowFormData;
	readonly children: React.ReactNode;
};

/**
 * Holds the group being edited and the reason its last save was refused. The draft is local to the
 * editor and is not a store: the leaves of the editor (stage cards, document rows, the document
 * settings screen) all read and replace it from here rather than receiving it through every level.
 */
const WorkflowDraftProvider: React.FC<Props> = ({ initialDraft, children }) => {
	const [draft, setDraft] = React.useState(initialDraft);
	const [refusalMessage, setRefusalMessage] = React.useState<string | null>(null);

	const value = React.useMemo(
		() => ({ draft, setDraft, refusalMessage, setRefusalMessage }),
		[draft, refusalMessage],
	);

	return <WorkflowDraftContext.Provider value={value}>{children}</WorkflowDraftContext.Provider>;
};

export default WorkflowDraftProvider;
